import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 99px;
  left: 112px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 800px;
  min-height: 43px;
  pointer-events: none;
`;

const Caption = styled.div`
  position: relative;
  padding: 9px 50px 10px 16px;
  min-height: 43px;
  background-color: rgba(0, 34, 29, 0.8);
  font-family: Open Sans;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  user-select: none;
  pointer-events: auto;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 13px;
  right: 16px;
  display: block;
  width: 17px;
  height: 18px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  cursor: pointer;
  pointer-events: auto;
`;

const Captions = ({ className }) => {
  const [isHidden, setIsHidden] = useState(false);
  const caption = useSelector(({ captions: { voice } }) => voice);

  const hideCaption = () => setIsHidden(true);

  useEffect(() => {
    if (!caption && isHidden) setIsHidden(false);
  }, [caption]);

  return isHidden || !caption ? null : (
    <Container className={className} data-dd-action-name="captions">
      <Caption>
        {caption}
        <CloseButton onClick={hideCaption} aria-label="Hide caption" data-dd-action-name="captions:close">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 18 19">
            <g fill="none" fillRule="evenodd">
              <path d="M17 4.9a2 2 0 0 0-3-2.8L9 7 3.9 2a2 2 0 0 0-2.8 2.8L6 10l-5 5.1a2 2 0 0 0 2.8 2.8L9 13l5.1 5a2 2 0 0 0 2.8-2.8L12 10l5-5.1z" /><path fill="#FFF" d="M17 3.9a2 2 0 0 0-3-2.8L9 6 3.9 1a2 2 0 0 0-2.8 2.8L6 9l-5 5.1a2 2 0 0 0 2.8 2.8L9 12l5.1 5a2 2 0 0 0 2.8-2.8L12 9l5-5.1z" />
            </g>
          </svg>
        </CloseButton>
      </Caption>
    </Container>
  );
};

Captions.propTypes = {
  className: PropTypes.string,
};

Captions.defaultProps = {
  className: '',
};

export default Captions;
